import axios from "axios";
import { config } from "../../config";
import { BuildingInput } from "src/types/buildings-input";

export class BuildingsService {

  public listBuildings = async (): Promise<any> => {
    try {
      const { serverUrl } = config;
      const buildings = await axios.get(
        serverUrl + "statistics/building/all"
      );
      return buildings.data;
    } catch (err) {
      return [];
    }
  };

  public listBuildingsMoreDetails = async (): Promise<any[]> => {
    try {
      const { serverUrl } = config;
      const buidlingsDetails = await axios.get(
        serverUrl + "statistics/reports/building/all/weekly-monthly"
      );
      return buidlingsDetails.data;
    } catch (err) {
      return [];
    }
  };

  public getOneById = async (id: string): Promise<any> => {
    try {
      const { serverUrl } = config;
      const buildingData = await axios.get(
        serverUrl + `statistics/building/${id}`
      );
      return buildingData.data;
    } catch (err) {
      return [];
    }
  };

  public create = async (data: BuildingInput): Promise<any> => {
    try {
      const { serverUrl } = config;
      const building = await axios.put(serverUrl + "statistics/building/new", data);
      return building.data;
    } catch (err) {
      throw new Error('Building creation error');
    }
  };

  public updateBuilding = async (data: any): Promise<any> => {
    try {
      const { serverUrl } = config;
      const building = await axios.put(serverUrl + "statistics/building/update", data);
      return building.data;
    } catch (err) {
      return {};
    }
  };


  public createMany = async (data: BuildingInput[]): Promise<any> => {
    try {
      if  (data && data.length) {
        const promiseArray: any[] = [];
        data.forEach((item) => promiseArray.push(this.create(item)));
        return Promise.all(promiseArray);
      }
    } catch (err) {
      throw new Error('Building creation error');
    }
  };

  public listBuildingStats = async (
    Id: string,
    from: string,
    to: string,
    filter: string
  ): Promise<any> => {
    try {
      const type = filter.includes("Month") ? "week" : "day";
      const { serverUrl } = config;
      const stats = await axios.get(
        serverUrl + `statistics/reports/building/${Id}/${from}/${to}/${type}`
      );
      return stats.data;
    } catch (err) {
      return [];
    }
  };
}
